var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.2 19q-.37 0-.664-.214a1.26 1.26 0 0 1-.43-.545l-2.186-5.5H2.25a.733.733 0 0 1-.75-.737.733.733 0 0 1 .75-.736h4.09a.84.84 0 0 1 .506.158q.219.157.334.415l2.02 5.095L13.687 5.76q.136-.33.43-.545.291-.214.662-.214t.664.214q.295.214.43.545l2.207 5.51h3.668a.733.733 0 0 1 .751.736.734.734 0 0 1-.75.736h-4.1a.82.82 0 0 1-.503-.158 1.03 1.03 0 0 1-.327-.414L14.78 7.063l-4.488 11.178a1.26 1.26 0 0 1-.43.545A1.1 1.1 0 0 1 9.2 19"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/status.8b2121c3.svg";